import { NavLink, useLocation } from 'react-router-dom';
import React from 'react';

const FilterNav = ({ activeTab, setActiveTab, currentPage, setCurrentPage }) => {
  const location = useLocation();

  // Helper function to determine if a link is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  const setActiveTabHandler = (tab) => {
    setCurrentPage(1);
    setActiveTab(tab);
  };

  return (
    <div className="category_listbox">
      <div className="category_box">
        <ul>
          <li onClick={() => setActiveTabHandler('all_crypto')} className={activeTab === 'all_crypto' ? 'active' : ''}>
            <NavLink >All Crypto</NavLink>
          </li>
          <li onClick={() => setActiveTabHandler('top_gainers')} className={activeTab === 'top_gainers' ? 'active' : ''}>
            <NavLink >Top Gainers</NavLink>
          </li>
          <li onClick={() => setActiveTabHandler('top_losers')} className={activeTab === 'top_losers' ? 'active' : ''}>
            <NavLink >Top Losers</NavLink>
          </li>
          <li onClick={() => setActiveTabHandler('trending')} className={activeTab === 'trending' ? 'active' : ''}>
            <NavLink >♻️ Trending</NavLink>
          </li>
          <li onClick={() => setActiveTabHandler('top_marketcap')} className={activeTab === 'top_marketcap' ? 'active' : ''}>
            <NavLink >🔥 Top Market Cap</NavLink>
          </li>
          <li onClick={() => setActiveTabHandler('defi')} className={activeTab === 'defi' ? 'active' : ''}>
            <NavLink >🔥 DeFi</NavLink>
          </li>
          <li onClick={() => setActiveTabHandler('nft')} className={activeTab === 'nft' ? 'active' : ''}>
            <NavLink >🔥 NFT</NavLink>
          </li>
          <li onClick={() => setActiveTabHandler('ai')} className={activeTab === 'ai' ? 'active' : ''}>
            <NavLink >🤖 AI Tokens</NavLink>
          </li>
          <li onClick={() => setActiveTabHandler('meme')} className={activeTab === 'meme' ? 'active' : ''}>
            <NavLink >🐶 Meme</NavLink>
          </li>            
        </ul>
      </div>
    </div>
  );
};

export default FilterNav;    